module.exports = __webpack_public_path__ + "static/media/Screenshot 2022-08-16 at 2.24 1.e34623fc.png";